const NovaModule = () => import('@pages/nova/NovaModule.vue')
const PetitionCreate = () => import('@pages/nova/NovaPetitionCreate.vue')
const FacilityBookingCreate = () => import('@pages/nova/NovaFacilityBookingCreate.vue')
const FacilityBookings = import('@pages/nova/NovaFacilityBookings.vue')
const Newsletters = () => import('@pages/communications/newsletters/NewsletterInternals.vue')
const AccountStatement = () => import('@pages/nova/NovaAccountStatement.vue')
const Confirmation = () => import('@pages/nova/NovaConfirmation.vue')
const RedirectToDashboard = () => import('@pages/nova/NovaRedirectToDashboard.vue')
const DocumentsIndex = () => import('@pages/communications/archives/ArchiveIndex.vue')
const AccountStatusIndex = () => import('@pages/accounting/InternalBills/Index.vue')
const VecitiendaIndex = () => import('@pages/marketplace/Index.vue')

import store from '../../store/'
import * as actions from '../../store/_actions'
import ls from '../../utils/localStorage'
import * as mutations from '../../store/_mutations'

export default {
    path: '/nova',
    component: NovaModule, 
    name: 'novaModule',
    children: [
        {
            path: 'pqrs',
            component: PetitionCreate,
            name: 'novaPqrs',
        },
        {
            path: 'facility-bookings',
            component: () => FacilityBookings,
            name: 'novaFacilityBookings',
        },
        {
            path: 'facility-booking-create',
            component: FacilityBookingCreate,
            name: 'novaFacilityBookingCreate',
        },
        {
            path: 'newsletters',
            component: Newsletters,
            name: 'novaNewsletters',
        },
        {
            path: 'account-statement',
            component: AccountStatement,
            name: 'novaAccountStatement',
        },
        {
            path: 'documents',
            component: DocumentsIndex,
            name: 'novaDocuments',
        },
        {
            path: 'user-account-statement',
            component: AccountStatusIndex,
            name: 'novaAccountStatus',
        },
        {
            path: 'confirmation',
            component: Confirmation,
            name: 'novaConfirmation',
            props: true,
        },
        {
            path: 'dashboard',
            component: RedirectToDashboard,
            name: 'novaRedirectDashboard',
            props: true,
        },
        {
            path: 'vecitienda',
            component: VecitiendaIndex,
            name: 'novaVecitienda',
            props: true,

        }
    ],
    async beforeEnter(to, from, next) {
        const payload = to.query.p
        const token = to.query.token
        console.log('beforeEnter', token)
        if (!payload) return next({ name: 'welcome' })
        await store.dispatch(actions.VERIFY_PERSON, { payload, token })
        next()
    },
}






